// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jasonbanner {
  position: relative;
  width: 80%;
  max-width: 50rem;
  padding: 0;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}
.jasonbanner > * {
  width: 100%;
}
.jasonbanner > :nth-child(2),
.jasonbanner > :nth-child(3),
.jasonbanner > :nth-child(4) {
  display: none;
}
@media (min-width: 320px) {
  .jasonbanner > * {
    width: 48%;
  }
  .jasonbanner > :nth-child(2) {
    display: block;
  }
}
@media (min-width: 480px) {
  .jasonbanner > * {
    width: 30%;
  }
  .jasonbanner > :nth-child(3) {
    display: block;
  }
}
@media (min-width: 768px) {
  .jasonbanner > * {
    width: 22%;
  }
  .jasonbanner > :nth-child(4) {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/JasonBanner/JasonBanner.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAGA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AAHJ;AAMI;EACI,WAAA;AAJR;AAQI;;;EAGI,aAAA;AANR;ACjBI;ED2BI;IACI,UAAA;EAPV;EAUM;IACI,cAAA;EARV;AACF;ACzBI;EDqCI;IACI,UAAA;EATV;EAYM;IACI,cAAA;EAVV;AACF;ACjCI;ED+CI;IACI,UAAA;EAXV;EAcM;IACI,cAAA;EAZV;AACF","sourcesContent":["@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/mixins\" as *;\n\n.jasonbanner {\n    position: relative;\n    width: 80%;\n    max-width: 50rem;\n    padding: 0;\n    overflow: hidden;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.75rem;\n\n    // all boxes\n    > * {\n        width: 100%;\n    }\n\n    // default: only first box visible\n    > :nth-child(2),\n    > :nth-child(3),\n    > :nth-child(4) {\n        display: none;\n    }\n\n    @include breakpoint($breakpoint-mobile) {\n        > * {\n            width: 48%;\n        }\n\n        > :nth-child(2) {\n            display: block;\n        }\n    }\n\n    @include breakpoint($breakpoint-tablet) {\n        > * {\n            width: 30%;\n        }\n\n        > :nth-child(3) {\n            display: block;\n        }\n    }\n\n    @include breakpoint($breakpoint-desktop) {\n        > * {\n            width: 22%;\n        }\n\n        > :nth-child(4) {\n            display: block;\n        }\n    }\n}\n","@mixin breakpoint($breakpoint) {\n    @media (min-width: $breakpoint) {\n        @content;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
